<template>
  <div>
    <template v-if="!canApproveMassive">
      <div class="px-16 pb-10 pt-4 text-zt-lg" :class="primaryTextClass">
        <v-alert danger :value="!canApproveMassive">{{ $t('message.LincensesApprovalPendingComponent.modal.cantApproveMassive') }}</v-alert>
      </div>
    </template>
    <template v-else>
      <div class="px-6 md:px-16 pb-10 pt-4 text-zt-lg" :class="primaryTextClass">
        <!-- Seleccion de segundo aprobador -->
        <v-autocomplete
          v-if="massiveApproverPermission"
          v-model="model"
          :color="primaryColor"
          :value="model.id"
          :items="items"
          :loading="isLoading"
          :search-input.sync="search"
          cache-items
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          :label="$t('message.LincensesApprovalPendingComponent.modal.approverPlaceholder')"
          return-object
          data-vs-autocomplete="approver"
        ></v-autocomplete>
        <!-- Aprobador por default -->
        <!-- && myId != licenseUser.aprobador.id -->
        <template v-if="(this.request[0].is_default_approver === 'f')">
          <zt-check-box
            v-if="(massiveApproverPermission || setAsDefaultApproverPermission)"
            v-model="defaultApprover"
            class="text-zt-dark-500 text-zt-lg"
            data-vs-check-box="defaultApprover"
          >{{ $t("message.LincensesApprovalPendingComponent.modal.defaultApproverPlaceholder") }}</zt-check-box>
        </template>
        <v-textarea
          :color="primaryColor"
          v-model="observations"
          :label="$t('message.LincensesApprovalPendingComponent.modal.observationsPlaceholder')"
          class="fieldPasswordDialog"
        ></v-textarea>
        <zt-input
          class="mt-2"
          v-model="password"
          name="password"
          id="password"
          :label="$t('message.LincensesApprovalPendingComponent.modal.placeholder')"
          type="password"
          data-vs-input="password"
        />
      </div>
      <div class="zt-modal-footer flex justify-center items-center p-4">
        <zt-button
          class="mr-1 text-zt-lg"
          outlined
          @click="$emit('close')"
          data-vs-button="close"
        >{{ $t("message.LincensesApprovalPendingComponent.modal.cancelButton") }}</zt-button>
        <zt-button
          class="ml-1 text-zt-lg"
          @click="approve()"
          :disabled="disabled"
          data-vs-button="approve"
        >{{ $t("message.LincensesApprovalPendingComponent.modal.okButton") }}</zt-button>
      </div>
    </template>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import Users from '@/apiClient/Users'
import { mapGetters } from 'vuex'

export default {
  props: {
    request: {
      type: Array,
      default: []
    }
  },
  data(){
    return{
      licenses: Licenses,
      users: Users,
      disabled: false,
      password: '',
      defaultApprover: false,
      observations: '',
      entries: [],
      isLoading: false,
      model:  {
        id: '0',
        nombre: '',
        apellido: '',
        name: '',
        usuario: ''
      },
      search: null,
      myId: 0,
      licenseUser: {},
      requestsObj: {},
      canApproveMassive: false,
      massiveApproverPermission: false,
      setAsDefaultApproverPermission: false
    }
  },
  componentes: {},
  created() {
    this.licenses = new Licenses()
    this.users = new Users()
    this.myId = this.getUser.id
    // this.users
    //   .getprofileById(this.request.id_usuario)
    //   .then(r => {
    //     this.licenseUser = r.data.results.data[0];
    //   })

    //Solicitudes en mismo estado
    this.requestsObj = {
      requests: this.request.map(row => row.id),
      status: this.request.map(row => row.estado),
      approvalLevels: this.request.map(row => row.niveles_aprobacion)
    }
    if(this.request.length > 0){
      this.canApproveMassive = this.requestsObj.status.every((val, i, arr) => val === arr[0]);
      this.canChooseApprover()
      this.canSetAsDefault()
      if(this.requestsObj.status.every(this.estadoDos) && this.getUser.aprobador){
        this.model = {
          id: this.getUser.aprobador.id.toString(),
          nombre: this.getUser.aprobador.nombre,
          apellido: this.getUser.aprobador.apellido,
          name: `${this.getUser.aprobador.nombre} ${this.getUser.aprobador.apellido}`,
          usuario: ''
        }
        this.search = this.getUser.aprobador.nombre.length > 0 ? `${this.getUser.aprobador.nombre} ${this.getUser.aprobador.apellido}` : null
      }
    }
  },
  computed: {
    ...mapGetters({ getUser: 'getUser', getTimerSweetAlert: 'getTimerSweetAlert' }),
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    },
    items() {
      return this.entries.map(entry => {
        let fullName = `${entry.nombre}`;
        const name =
          fullName.length > this.descriptionLimit
            ? fullName.slice(0, this.descriptionLimit) + "..."
            : fullName;

        return Object.assign({}, entry, { name });
      });
    }
  },
  watch: {
    search(val) {
      if(val.length > 2){
        if (this.isLoading) return;
        this.isLoading = true;
        this.users.searchUsersv2(val)
          .then(res => {
            let entries = res.data.data;
            let results = [];
            for (let i = 0; i < entries.length; i++) {
              if(entries[i].id != this.myId){
                results.push(entries[i]);
              }
            }
            this.entries = results;
          })
          .catch(err => {})
          .finally(() => (this.isLoading = false));
      }
    }
  },
  methods: {
    async approve() {
      this.disabled = true
      let approver = null;
      let errors = []
      for(let i=0; i < this.request.length; i++){
        if(this.model.id !== '0' && this.massiveApproverPermission){
          approver = this.model.id;
        }
        await this.licenses
          .ApprovalPendingLicenses(
            this.request[i].id,
            this.observations,
            approver, //siguiente aprobador
            this.password,
            this.defaultApprover ? 1 : 0,
          )
          .then(() => {})
          .catch(error => {
            errors.push(error)
          });
      }
      if(errors.length > 0){
        this.disabled = false
        this.$swal({
          type: "error",
          title: errors.length === 1 ? this.$t(`message.errorReference.${this.customErrorMessges(errors)}`): this.$t("message.LincensesApprovalPendingComponent.modal.massiveApproveError"),
          showConfirmButton: true,
          confirmButtonText: this.$t("message.settingsComponent.list.okMsg")
        });
      }else{
        this.$swal({
          type: "success",
          title: this.$t(
            "message.LincensesApprovalPendingComponent.modal.approveLicenseOk"
          ),
          timer: this.getTimerSweetAlert,
          showConfirmButton: false
        })
        this.$emit('close')
        this.$emit('refresh-table')
        this.$emit('clean-massive-array')
      }
    },
    customErrorMessges(error){
      const code = error[0].response.data.results.data[0] === 'La licencia no puede comenzar un dia feriado.' ? '02101' : error[0].response.data.response_v2.code;
       const message = error[0].response.data.response_v2.message

       const sichernPeopleErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_ABSENCE_BAD_REQUEST$/g.test(code);
       const handledMessages = ['StatusNotAllowed','ProcessedAbsenceExists', 'AbsenceNotExists','AbsenceStatusNotValidForOperation','ErrorDeletingReviewStatus','OnlyRejectedTheLastOpeningAbsence','InvalidDateRange']
       if (sichernPeopleErrorCodeRegex && handledMessages.some(x => x == message)) {
         return `${code}_${message}`
       } else {
        return code;
       }
    },
    canChooseApprover(){
      if(this.requestsObj.status.every(this.estadoDos) && this.requestsObj.approvalLevels.every(this.nivelesDos)){
        //this.aprobacion.searchUsers.value = this.aprobadorDeJefe
        this.massiveApproverPermission = true
      }else{
        this.massiveApproverPermission = false
      }
    },
    estadoDos(currentValue){
      return currentValue === "2";
    },
    nivelesDos(val){
      return val === "2";
    },
    canSetAsDefault(){
      if(this.requestsObj.status.every(this.estadoTres) && this.requestsObj.approvalLevels.every(this.nivelesUno)){
        this.setAsDefaultApproverPermission = true
        return
      }
      this.setAsDefaultApproverPermission = false
    },
    estadoTres(currentValue){
      return currentValue === "3";
    },
    nivelesUno(val){
      return val === "1";
    },
  }

}
</script>

<style lang="scss" scoped>
.text-iframe-primary {
  color: #2694fc !important;
}
</style>
